export enum NotificationObjectType {
  MESSAGE = 'message',
  REFERRAL = 'referral',
}

export enum NotificationVerb {
  // REFERRAL SHARES
  NEW_REFERRAL_SHARE = 'new_referral_share',
  REFERRAL_SHARE_RECEIVER_TIME_BASED = 'referral_share_receiver_time_based',
  REFERRAL_SHARE_SENDER_TIME_BASED = 'referral_share_sender_time_based',
  REFERRAL_SHARE_INTERESTED = 'referral_share_interested',
  REFERRAL_SHARE_APPROVED = 'referral_share_approved',
  REFERRAL_SHARE_RECEIVER_DECLINED = 'referral_share_receiver_declined',
  REFERRAL_SHARE_SENDER_DENIED = 'referral_share_sender_denied',
  REFERRAL_SHARE_EXPIRED = 'referral_share_expired',

  // Team invitations
  TEAM_INVITATION_SENT = 'team_invitation_sent',
  TEAM_INVITATION_INTERESTED = 'team_invitation_interested',
  TEAM_INVITATION_APPROVED = 'team_invitation_approved',
  TEAM_INVITATION_DECLINED_BY_INVITEE = 'team_invitation_declined_by_invitee',
  TEAM_INVITATION_DECLINED_BY_CONSUMER = 'team_invitation_declined_by_consumer',
  TEAM_INVITATION_EXPIRED = 'team_invitation_expired',
  TEAM_INVITATION_AUTO_REJECTED = 'team_invitation_auto_rejected',

  // LICENSE VERIFICATION
  LICENSE_VERIFICATION = 'license_verification',

  // POINTS
  POINTS_RECEIVED = 'points_received',

  // FEED
  NEW_COMMENT_ON_POST = 'new_comment_on_post',
  NEW_COMMENT_ON_COMMENT = 'new_comment_on_comment',
  NEW_LIKE_ON_POST = 'new_like_on_post',
  NEW_LIKE_ON_COMMENT = 'new_like_on_comment',

  // CHAT
  NEW_MESSAGE = 'new_message',
  REFERRAL_NEW_MESSAGE = 'referral_new_message',
  PARTNER_MATCH_NEW_MESSAGE = 'partner_match_new_message',
  NETWORK_NEW_MESSAGE = 'network_new_message',
  SNEAK_NEW_MESSAGE = 'sneak_new_message',

  // SYSTEM
  SYSTEM = 'system',
  WEEKLY_RECAP = 'weekly_recap',

  // PARTNER MATCH
  PARTNER_MATCH_WEEKLY_RESET = 'partner_match_weekly_reset',
  PARTNER_MATCH_UNLOCKED = 'partner_match_unlocked',

  // LEAD INQUIRY
  LEAD_INQUIRY_RECEIVED = 'lead_inquiry_received',
  LEAD_INQUIRY_REMINDER = 'lead_inquiry_reminder',
  LEAD_INQUIRY_COMPETITION = 'lead_inquiry_competition',
  LEAD_INQUIRY_TAKEN = 'lead_inquiry_taken',

  // LEAD CREDITS
  LEAD_CREDIT_REWARD_RECEIVED = 'lead_credit_reward_received',

  // One-time
  ONE_TIME = 'one_time',

  // Twilio
  TWILIO_NUMBER_SELECTION = 'twilio_number_selection',
  TWILIO_BRAND_FAILED = 'twilio_brand_failed',
  TWILIO_CAMPAIGN_FAILED = 'twilio_campaign_failed',

  // Lynk
  LYNK_COMPLETED = 'lynk_completed', // Lynk has completed the workflows for a business
  LYNK_NEED_ASSISTANCE = 'lynk_need_assistance', // Lynk needs user assistance (consumer asks questions that require professional help, consumer requests human, etc.)
  LYNK_HOSTILE = 'lynk_hostile', // Consumer is hostile (consumer is rude, etc.)
  LYNK_EXTREME_CASE = 'lynk_extreme_case', // Consumer is in an extreme case (consumer is in a dangerous situation, etc.)
  LYNK_OFF_TOPIC = 'lynk_off_topic', // Consumer is off-topic
  LYNK_DISABLED = 'lynk_disabled', // Consumer opted out
  LYNK_FAILED = 'lynk_failed', // Lynk has failed

  // Enterprise invitations
  ENTERPRISE_INVITATION_SENT = 'enterprise_invitation_sent',
  ENTERPRISE_INVITATION_ACCEPTED = 'enterprise_invitation_accepted',
  ENTERPRISE_INVITATION_DECLINED = 'enterprise_invitation_declined',
  ENTERPRISE_INVITATION_CANCELED = 'enterprise_invitation_canceled',
  ENTERPRISE_INVITATION_EXPIRED = 'enterprise_invitation_expired',
}
